<template>
  <footer>
    <el-row v-if="page.indexOf('Admin') == -1" type="flex" align="middle" style="position:fixed;bottom:0;width:100%;z-index: 2;">
      <swiper :options="swiperOption" ref="mySwiper" style="width: 100%;background-color: black; color: antiquewhite; z-index: 10; height: 48px;">
        <el-col :span="8" style="width:100%">
          <swiper-slide @click.native="$routerTo('/Home')" :class="{ select: page.indexOf('Home') > -1 }">
            <i class="el-icon-s-home" style="font-size: 36px;margin-top: 6px;"></i>
          </swiper-slide>
        </el-col>

        <el-col :span="8" style="width:100%">
          <swiper-slide @click.native="$routerTo('/Sort')" :class="{ select: page.indexOf('Sort') > -1 }">
            <i class="el-icon-search" style="font-size: 36px;margin-top: 6px;"></i>
          </swiper-slide>
        </el-col>

        <el-col :span="8" style="width:100%">
          <swiper-slide @click.native="$routerTo('/Scan')" :class="{ select: page.indexOf('Scan') > -1 }">
            <i class="el-icon-camera-solid" style="font-size: 36px;margin-top: 6px;"></i>
          </swiper-slide>
        </el-col>
      </swiper>
    </el-row>

    <div v-else style="font-size:12px; color:black; word-spacing:1px; font-weight:bold; height:48px">
      <div style="padding-top: 18px;">
        <span>{{ Copyright }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  data() {
    return {
      Copyright: "",
      swiperOption: {
        slidesPerView: "auto"
      }
    };
  },
  computed: {
    ...mapState(["page"])
  },
  mounted() {
    var tm = new Date();
    var y = tm.getFullYear();
    var cp = "";
    if (y == "2019") cp = y;
    else cp = "2019 - " + y;
    this.Copyright = "Copyright " + cp + " www.taogmuseum.org";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select {
  color: black;
  background-color: antiquewhite;
}
</style>
